import { checkExactLength, checkNotEmpty } from '../../helpers/validators';
export const validateMirCardNumber = ({ value, required }) => {
    const standartCardNumberLength = 16;
    const enlargedСardNumberLength = 19;
    const cardNumberLength = value?.length <= standartCardNumberLength ? standartCardNumberLength : enlargedСardNumberLength;
    const message = `Должно быть ${standartCardNumberLength} или ${enlargedСardNumberLength} цифр`;
    if (required) {
        return (checkNotEmpty({ value }) ||
            checkExactLength({
                value,
                message,
                length: cardNumberLength,
            }));
    }
    return value ? checkExactLength({ value, message, length: cardNumberLength }) : null;
};
